import { EventType } from './types';
export const orderEvents = [
    EventType.OrderCreated,
    EventType.OrderInvalid,
    EventType.OrderBalanceChange,
    EventType.OrderAllowanceChange,
    EventType.OrderFilled,
    EventType.OrderFilledPartially,
    EventType.OrderCancelled,
    EventType.OrderSecretShared
];
//# sourceMappingURL=constants.js.map